import {MasterLayout} from 'layout';
import React from 'react';
import { Link } from 'react-router';
import { Button, Dialog, label } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemLetters} from './datatable/list';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import {TextArea, Input, DropDownTreeMultipleSelect, DropDown} from 'components/tt-forms/common';
import {DropDownChonLoaiDonThu} from 'components/tt-forms';
import { InputTuKhoa } from 'modules/reception/form-timkiem';
import {ConfirmDialog} from 'modules/dialog';

class Letters extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      categoryName: '',
      maTTCP : '',
      isValid: true,
      parentCategory: '',
      categoryDesc: '',
      categoryId: 0,
      tableLoading:false,
      buttonLoading: false,
      loaiDonId: '',
      searchLoading: false,
      tuKhoa:'',
      search: false,
      timKiemNangCao: false,
      loaiDonFilter: '',
      linhVucFilter: [],
      linhVucTimKiemList: [],
      dialogConfirm: false,
      dialogConfirmContent: '',
      idDeleteConfirm: ''
    };
  }

  componentDidMount() {
    this.getListData();
    this.getLinhVucDonThuSearch();
  }

  getLinhVucDonThuSearch() {
    Danhmuc.actions.getLinhVucDonThuTimKiem.request().then(res => {
      if (res.data && res.data._embedded) {
        this.setState({linhVucTimKiemList: res.data._embedded.linhVucDonThus});
      }
    });
  }

  onChange(name, e) {
    if (name == 'linhVucTimKiem') {
      this.setState({linhVucFilter: e});
    } else {
      this.setState({[name]: e.target.value});
    }
  }

  handleSearch(e) {
    e.preventDefault();
    this.setState({
      search: true,
      pageData : {
        number: 0,
        size: 10,
        totalElements: 0
      }
    }, () => {
      this.getListData(true);
    });
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if (this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    if (this.state.timKiemNangCao) {
      if (this.state.loaiDonFilter) {
        params.loaiDon = this.state.loaiDonFilter;
      }
      if (this.state.linhVucFilter.length) {
        let ids = [];
        this.state.linhVucFilter.map(item => {
          ids.push(item.value);
        });
        params.listLinhVucs = ids.join();
      }
    }
    Danhmuc.actions.getLinhVucDonThu.request(null, params).then(res => {
     if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.linhVucDonThus,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        if(this.state.pageData.number > 0){
          this.setState({pageData: {
            ...this.state.pageData,
            number: this.state.pageData.number - 1
          }}, () => {
            this.getListData();
          })
        }
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size: size,
        number: 0
      }
    }, () => {
      this.getListData();
    })
  }

  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  createCategory() {
    if(this.checkValidate()){
      let params = {
        ten: this.state.categoryName.trim(),
        moTa: this.state.categoryDesc.trim(),
        loaiDon: this.state.loaiDonId,
        maTTCP: this.state.maTTCP,
      };
      if (this.state.parentCategory) {
        params.cha = {
          id: this.state.parentCategory.linhVucDonThuId
        };
      }
      this.setState({buttonLoading: true});
      if (this.state.addType == 2) {
        Danhmuc.actions.updateLinhVucDonThu.request({id: this.state.categoryId},params).then(res => {
          this.getListData();
          this.toggleDialog('popupAddCategory', false);
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
          this.getLinhVucDonThuSearch();
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        Danhmuc.actions.postLinhVucDonThu.request('',params).then(res => {
          this.getListData();
          this.toggleDialog('popupAddCategory', false);
          Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
          this.getLinhVucDonThuSearch();
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    }, () => {
      this.getListData();
    })
  }

  handleDelete(categoryId) {
   if(categoryId){
      this.setState({buttonLoading: true});
      let params = {};
      if (this.state.idDeleteConfirm) {
        params.delAll = true;
      }
      Danhmuc.actions.deleteLinhVucDonThu.request({id: categoryId}, params).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false, idDeleteConfirm: '', dialogConfirm: false});
        this.getLinhVucDonThuSearch();
      }).catch(error => {
        if (error.response) {
          if (error.response.data.errors[0].code == 'NOTIFY_CONFIRM') {
            this.setState({
              idDeleteConfirm: categoryId,
              buttonLoading: false,
              dialogConfirmContent: error.response.data.errors[0].detail,
              dialogConfirm: true
            });
          } else {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        }
      });
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  toggleDialog(name, status) {
    this.setState({[name]: status});
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {
    this.toggleDialog('popupAddCategory', true);
    this.setState({
      addType:0,
      categoryName: '',
      maTTCP: '',
      parentCategory: '',
      categoryDesc: '',
      isValid: true,
      loaiDonId: this.props.loaiDonThu.length ? this.props.loaiDonThu[0].giaTri : ''
    });
  }

  openAddMoreCategory(item) {
    this.toggleDialog('popupAddCategory', true);
    this.setState({
      addType:1,
      categoryId: '',
      categoryName: '',
      parentCategory: item,
      categoryDesc: '',
      isValid: true,
      loaiDonId: item.loaiDon,
      maTTCP: '',
    });
  }

  openUpdateCategory(item) {
    this.setState({
      popupAddCategory : true,
      addType : 2,
      categoryId : item.linhVucDonThuId,
      categoryName : item.ten,
      maTTCP: item.maTTCP,
      parentCategory : item.linhVucDonThuCha,
      categoryDesc : item.moTa,
      loaiDonId : item.loaiDon,
      isValid : true
    });
  }
  toggleSearch(status) {
    if (status) {
      this.setState({timKiemNangCao : true});
    } else {
      this.setState({timKiemNangCao : false});
    }
  }

  onConfirmDelete() {
    this.handleDelete(this.state.idDeleteConfirm);
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Lĩnh vực đơn thư</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('LINHVUCDONTHU_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <div className={ this.state.timKiemNangCao ? 'search-container super-search' : 'search-container' }>
              <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
                <InputTuKhoa value={this.state.tuKhoa} onChange={ this.onChange.bind(this, 'tuKhoa') } placeholderText="Nhập từ khóa để tìm kiếm..." />
                <DropDown label="Loại đơn" selectedValue={this.state.loaiDonFilter} onChange={ this.onChange.bind(this, 'loaiDonFilter') } options={this.props.loaiDonThu} keyName="giaTri" valueName="ten" placeholder/>
                <div className="btn-wrap">
                  <Button className={`btn-green tt-search`} text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
                </div>
                {
                  this.state.timKiemNangCao?
                    <div className='clear-left'>
                      <DropDownTreeMultipleSelect className="tree-selected" label="Lĩnh vực đơn thư" dataOptions={this.state.linhVucTimKiemList} dataSelected={this.state.linhVucFilter} onChange={this.onChange.bind(this, 'linhVucTimKiem')} selectAllChildren={false} propertyChildren='linhVucDonThuCha' propertyParent='linhVucDonThuId'/>
                      <div className="input-group" style={{float: 'right'}}>
                        <Link className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" } onClick={ this.toggleSearch.bind(this, false) }><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
                      </div>
                    </div>
                  :''
                }
              </form>
              <Link className="rearch-text" onClick={ this.toggleSearch.bind(this, true) }><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <DataTable
              header = {header.categoryGroup.letters}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideButtonExport
              parent= {this}
              tableLoading = {this.state.tableLoading}
            >
              <RowItemLetters/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.toggleDialog.bind(this, 'popupAddCategory', false)}
            title={this.state.addType == 2 ? 'Chỉnh sửa lĩnh vực đơn thư' : 'Thêm mới lĩnh vực đơn thư'}
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body row">
              <DropDownChonLoaiDonThu className="col-12" label="Loại đơn thư" selectedValue={this.state.loaiDonId} placeholder={null} onChange={this.onChange.bind(this, 'loaiDonId')}/>
              <Input className="col-12" label="Mã TTCP" value={this.state.maTTCP} require={false} maxLength={40} onChange={this.onChange.bind(this, 'maTTCP')} channel="danhMuc"/>
              <Input className="col-12" label="Tên" value={this.state.categoryName} require={true} maxLength={40} onChange={this.onChange.bind(this, 'categoryName')} bindValidator={this} channel="danhMuc"/>
              {
                this.state.parentCategory ?
                  <div className="col-12">
                    <label className="pt-label">
                     Lĩnh vực đơn thư cha: {this.state.parentCategory.ten}
                    </label>
                  </div>
                : null
              }
              <TextArea label="Mô tả" maxLength={255} rows={5} value={this.state.categoryDesc} onChange={this.onChange.bind(this, 'categoryDesc')} className='col-12'/>
            </div>
            <div className="pt-dialog-footer">
                <Link onClick={this.toggleDialog.bind(this, 'popupAddCategory', false)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)} >
                  <span>{this.state.addType == 2 ? 'Cập nhật' : 'Thêm mới'}</span>
                </Link>
            </div>
          </Dialog>
          <ConfirmDialog open={this.state.dialogConfirm} onClose={this.toggleDialog.bind(this, 'dialogConfirm', false)} onSuccess={this.onConfirmDelete.bind(this)} title={this.state.dialogConfirmContent} />
        </div>
      </MasterLayout>
    );
  }
}
Letters.defaultProps = {
  validators: {}
}
function bindStateToProps(state) {
  return {
    loaiDonThu: state.duLieuHeThong.loaiDonThu
  };
}

export default connect(bindStateToProps)(Letters);



// WEBPACK FOOTER //
// ./src/components/modules/category/Letters.jsx